export const annaChwialkowska = {
    'meta': {
        'title': 'Psycholog, psychoterapeuta Anna Chwiałkowska-Dąbkowska',
        'description': 'Jestem psychologiem i psychoterapeutą w trakcie szkolenia z zakresu psychoterapii integracyjnej. Pracuję średnio i długoterminowo z osobami dorosłymi.'
    },
    'url': {
        'address': '/torun/zespol/psycholog-psychoterapeuta-anna-chwialkowska-dabkowska/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/anna-chwialkowska-dabkowska.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psycholog w Toruniu, Psychoterapeuta w Toruniu Anna Chwiałkowska-Dąbkowska'
        }
    }
}